import { useContext, useState, useRef, useEffect } from 'react';
import { GlobalMobileContext } from '../../contexts/globalMobileContext'
import "./pages.css";
import TagComponent from '../../components/projectList/TagComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';
import DetailCountComponent from '../../components/projectList/DetailCountComponent';
import DarkButtonComponent from '../../components/commons/DarkButtonComponent';

import styles from './Mobile_ProjectsListPage.module.css'

const Mobile_ProjectsListPage = () => {
    const { mobileSocketRef, setConferencesList, currentUser, setCurrentPage, setCurrentProject } = useContext(GlobalMobileContext);
    const [entities, setEntities] = useState([])
    const entityName = "Project";


    useEffect(() => {
        mobileSocketRef.current.emit("MOBILE_GET_ALL_PROJECTS", currentUser._id, (projects) => {
            setEntities(projects)
        });

    }, []);

    const openProject = (project) => {
        mobileSocketRef.current.emit("MOBILE_GET_CONFERENCES_BY_PROJECT", project._id, currentUser._id, (conferences) => {
            setCurrentPage("Conferences")
            setConferencesList(conferences)
            setCurrentProject(project)
        });
    }

    function formatDates(stringDate) {
        const date = new Date(stringDate)
        return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`
    }


    return (
        <>
            <div className={styles.pageTitleProjects}>
                <h1 className={styles.title}>Welcome back, <b>{currentUser.name}</b></h1>
            </div>

            <section className={styles.sectionScroll}>
                <div className={styles.row}>
                    <div>
                        <h1 className={styles.projectsTitle}>{entityName}s ({entities.length})</h1>
                        {entities.map((entity) => (
                            <div key={entity._id} className={styles.projectCard}>
                                <div className={styles.projectCardBody} >
                                    <TagComponent status="active" text="Active" fontSize={8} height={14} margin={0} padding="2px 8px" />
                                    <div style={{ marginTop: 5 }}>{entity.name}</div>
                                    <div className={styles.detailsDate}>Date created: <strong style={{ color: '#FFFFFF' }}>{formatDates(entity.createdDate)}</strong></div>
                                    <div className={styles.horizontalLine}/>
                                    <div className={styles.projectDetails}>
                                        <div className={styles.projectDetail}>
                                            <div className={styles.detailName}>
                                                <FontAwesomeIcon className={styles.iconDetail} icon={byPrefixAndName.fal["users-rectangle"]} />
                                                Conferences
                                            </div>
                                            {entity.nrConferences}
                                        </div>
                                        <div className={styles.projectDetail} style={{ borderLeft: "1px solid #FFFFFF33" }}>
                                            <div className={styles.detailName}>
                                                <FontAwesomeIcon className={styles.iconDetail} icon={byPrefixAndName.fal["rocket"]} />
                                                Presentations
                                            </div>
                                            {entity.nrPresentations}
                                        </div>
                                    </div>
                                    <div className={styles.horizontalLine} />
                                    <div className={styles.cardTags} style={{ gap: "0px", justifyContent: "space-evenly", flexWrap: "wrap" }}>
                                        <DetailCountComponent project={entity} type={"nrTopics"} style={{ fontSize: "12px", lineHeight: "14px", gap: "2px", marginLeft: 0 }}
                                            iconFontSize={10} iconMargin="2px 5px 0px 0px" compMargin="10px 13px 0px 0px" />
                                        <DetailCountComponent project={entity} type={"nrSubtopics"} style={{ fontSize: "12px", lineHeight: "14px", gap: "2px", marginLeft: 0 }}
                                            iconFontSize={10} iconMargin="2px 5px 0px 0px" compMargin="10px 13px 0px 0px" />
                                        <DetailCountComponent project={entity} type={"nrNotes"} style={{ fontSize: "12px", lineHeight: "14px", gap: "2px", marginLeft: 0 }}
                                            iconFontSize={10} iconMargin="2px 5px 0px 0px" compMargin="10px 13px 0px 0px" />
                                        <DetailCountComponent project={entity} type={"nrFiles"} style={{ fontSize: "12px", lineHeight: "14px", gap: "2px", marginLeft: 0 }}
                                            iconFontSize={10} iconMargin="2px 5px 0px 0px" compMargin="10px 13px 0px 0px" />
                                    </div>
                                    <DarkButtonComponent
                                        style={{ width: "70%", height: "38px", backgroundColor: "transparent", fontSize: "18px", lineHeight: "20px", borderRadius: "4px", 
                                            border: "1px solid #33FFC8", marginTop: "5px" }}
                                        onClick={() => openProject(entity)}>
                                        Open
                                    </DarkButtonComponent>

                                </div>

                            </div>
                        ))}
                    </div>
                </div>
                <div className='topShadow'/>
                <div className='bottomShadow'/>
            </section>
        </>
    );
}

export default Mobile_ProjectsListPage;
